import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { Outlet } from 'react-router-dom'

import { paths } from 'src/config/paths'
import AuthSidebar from 'src/features/auth/components/sidebar'
import { queries } from 'src/lib/query-keys'
import { useAuthState } from 'src/shared/features/auth/api/use-auth-state'
import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { cn } from 'src/shared/utils/cn'

export default function AuthLayout() {
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  const queryClient = useQueryClient()
  const { isSignedIn, needsOnboarding } = useAuthState()
  const [searchParams] = useSearchParams()
  const redirectTo = searchParams.get('redirectTo')

  useEffect(() => {
    const cachedUser = queryClient.getQueryData(queries.users.me.queryKey)

    if (cachedUser) {
      navigate(redirectTo ? redirectTo : paths.home.getHref(), {
        replace: true,
      })
    } else if (isSignedIn && needsOnboarding) {
      navigate(paths.auth.onboarding.getHref(redirectTo || ''), {
        replace: true,
      })
    } else if (isSignedIn && !needsOnboarding) {
      navigate(redirectTo ? redirectTo : paths.home.getHref(), {
        replace: true,
      })
    }
  }, [isSignedIn, needsOnboarding, queries.users.me.queryKey, redirectTo, navigate])

  return (
    <div
      className={cn(
        'flex',
        !isMobile && 'h-screen overflow-clip',
        isMobile ? 'h-full min-h-screen flex-col justify-between' : 'flex-row',
      )}
    >
      {!isMobile && <AuthSidebar />}
      <div
        className={cn(
          'mx-auto flex w-full max-w-[650px] shrink-0 flex-col justify-between gap-6 overflow-y-auto',
          isMobile ? 'h-full max-h-none items-center' : 'px-8',
        )}
      >
        <Outlet />
      </div>
    </div>
  )
}
